/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetPhoneRequestAllOf } from './GetPhoneRequestAllOf';
import {
    GetPhoneRequestAllOfFromJSON,
    GetPhoneRequestAllOfFromJSONTyped,
    GetPhoneRequestAllOfToJSON,
} from './GetPhoneRequestAllOf';

/**
 * 
 * @export
 * @interface GetPhoneRequest
 */
export interface GetPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof GetPhoneRequest
     */
    placeId?: string;
}

/**
 * Check if a given object implements the GetPhoneRequest interface.
 */
export function instanceOfGetPhoneRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPhoneRequestFromJSON(json: any): GetPhoneRequest {
    return GetPhoneRequestFromJSONTyped(json, false);
}

export function GetPhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPhoneRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'placeId': !exists(json, 'placeId') ? undefined : json['placeId'],
    };
}

export function GetPhoneRequestToJSON(value?: GetPhoneRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'placeId': value.placeId,
    };
}

